import { Box, Icon } from "orcs-design-system";
import PropTypes from "prop-types";

const PersistedMoveIndicator = ({
  testId = "cp-persisted-move-info",
  onMouseEnter,
  onFocus,
  onClick,
}) => (
  <Box
    data-testid={testId}
    width="20px"
    height="20px"
    borderRadius="20px"
    bg="white"
    border="1px solid"
    borderColor="greyDarkest"
    display="inline-flex"
    alignItems="center"
    justifyContent="center"
    onMouseEnter={onMouseEnter}
    onFocus={onFocus}
    onClick={onClick}
  >
    <Icon
      icon={["far", "location-pin-lock"]}
      color="greyDarkest"
      aria-hidden
      fontSize="1.1rem"
    />
  </Box>
);

PersistedMoveIndicator.propTypes = {
  testId: PropTypes.string,
  onMouseEnter: PropTypes.func,
  onFocus: PropTypes.func,
};

export default PersistedMoveIndicator;
